import advanceAdressStatus from './advanceAdressStatus';

/**
 * `VisitDone` wordt door onze eigen knop als boolean geschreven, maar een
 * document dat ooit via een ToggleButton liep kan de string dragen.
 * AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches
 *
 * @param {object|null|undefined} task - Het taakdocument
 * @returns {boolean}
 */
const isVisitDone = (task) => {
    if (!task || typeof task !== 'object') return false;
    return task.VisitDone === true || task.VisitDone === 'true';
};

/**
 * Mag dit afgeronde huisbezoek het huishouden op 'Afgerond' zetten?
 *
 * De spiegel van `shouldAutoMarkPlanned`, met één verschil: hier moet het bezoek
 * ook daadwerkelijk als afgerond gemarkeerd zijn. Dat is een expliciete
 * handeling en geen afleiding uit een datum die voorbij is of subtaken die
 * afgevinkt staan — een bezoek waar niemand kwam opdagen ligt ook in het
 * verleden, en bij de klant die hierom vroeg staan de subtaken allemaal nog
 * open. Een automaat die nooit afgaat is niet te onderscheiden van een kapotte.
 *
 * **Let op wat 'Afgerond' betekent.** Dat is het einde van de héle trechter,
 * niet het einde van één bezoek. Vandaar dat dit achter een instelling per
 * organisatie zit die standaard uit staat: bij wie een traject meer bezoeken
 * telt, sluit het eerste afgeronde bezoek het huishouden te vroeg.
 *
 * AI-CONTEXT: See docs/features/afgerond-bezoek-status.md
 *
 * @param {object|null|undefined} task - Het opgeslagen taakdocument
 * @param {string|null|undefined} currentStatus - De huidige Adresses.Status
 * @returns {boolean}
 */
const shouldAutoMarkCompleted = (task, currentStatus) => {
    if (!isVisitDone(task)) return false;
    return advanceAdressStatus(task, currentStatus, 'completed');
};

export { isVisitDone };
export default shouldAutoMarkCompleted;
